import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input, OnInit } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { Observable, Subject } from 'rxjs';

import { BaseTreeItem, LeftNavType } from '../../../event-details-common/event-details-common.models';
import { PopupManager } from '../../../popup/popup-manager.service';
import { EventSwitcherDataService } from '../services/event-switcher-data.service';

@Component({
    selector: 'ms-event-switcher',
    templateUrl: './event-switcher.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [EventSwitcherDataService],
    standalone: false,
})
export class EventSwitcherComponent implements OnInit {
    @Input() event: EventModel;

    private viewModel: Subject<BaseTreeItem> = new Subject<BaseTreeItem>();
    get viewModel$(): Observable<BaseTreeItem> {
        return this.viewModel;
    }

    @HostBinding('class') className = 'event-switcher';

    constructor(
        private dataProvider: EventSwitcherDataService,
        private popupManager: PopupManager,
        private epcotConfig: EpcotConfig,
    ) {}

    @HostListener('click', ['$event'])
    click(event: Event): void {
        event.stopPropagation();
    }

    ngOnInit(): void {
        this.loadEvents();
    }

    private async loadEvents(): Promise<void> {
        const type = this.isEpcotEnabled ? LeftNavType.Competition : this.event.live ? LeftNavType.Live : LeftNavType.Prematch;

        this.dataProvider.getEventsTree(this.event, type).subscribe((tree) => {
            if (tree) {
                this.viewModel.next(tree);

                this.updateEpcotPopupTitle(tree);
            }
        });
    }

    private updateEpcotPopupTitle(tree: BaseTreeItem): void {
        if (this.isEpcotEnabled) {
            const eventCount = tree.children[0].count;
            const newTitle = this.event.league.name + ((eventCount ?? 0 > 1) ? ` (${eventCount})` : '');
            this.popupManager.updateDialogTitle('event-switcher', newTitle);
        }
    }

    get isEpcotEnabled(): boolean {
        return this.epcotConfig.isEnabled;
    }
}
